import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ThisPlatform } from "src/app/_services/platform.service";
import { RowsLoaderService } from "src/app/_services/rows-loader.service";
import { PaginationClientSideOptions } from "../../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../../_component/pagination-client-side/pagination-column.class";
import { GuestReportViewComponent } from "../guest-report/guest-report-view/guest-report-view.component";
import { GuestReportService } from "./guest-report.service";
import { GuestReport, GuestReportType } from "./guest-report.model";
import { BuildingService } from "../../building/building.service";
import { UserService } from "src/app/_services";
import { DateTimeAdapter } from "@danielmoncada/angular-datetime-picker";
import {
  AlertController,
  ModalController,
  PopoverController,
} from "@ionic/angular";
import { CompanyService } from "../../company/company.service";
import { GuestReportModalFilterComponent } from "./guest-report-modal-filter/guest-report-modal-filter.component";
import { DateStiPipe } from "src/app/_pipes/date-sti.pipe";
import { FormControl, FormGroup } from "@angular/forms";
import { customValidators } from "src/app/_helpers/customValidators";
import { preventSwipeToClose } from "src/app/_helpers/preventSwipeToClose";

@Component({
  selector: "app-guest-report",
  templateUrl: "./guest-report.component.html",
  styleUrls: ["./guest-report.component.scss"],
})
export class GuestReportComponent implements OnInit {
  guestReportsFilter: GuestReport[];

  rowsLoader: RowsLoaderService;
  componentRef: any = GuestReportViewComponent;
  showLoader: boolean = true;
  form: FormGroup;

  columnsDefinition: PaginationColumn[] = [
    {
      name: "buildingName",
      displayName: "ADMIN.GUEST_REPORT.BUILDING",
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.buildingName;
      },
    },
    {
      name: "companyName",
      displayName: "ADMIN.GUEST_REPORT.COMPANY",
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.companyName;
      },
    },
    {
      name: "day",
      displayName: "ADMIN.GUEST_REPORT.DAY",
      size: 2,
      sortable: true,
      colValue: (res) => {
        return new Date(
          this.datePipe.transform(res.date, "onlyDate", "en") + ""
        );
      },
    },
    {
      name: "enterQuantity",
      displayName: "ADMIN.GUEST_REPORT.ENTRY_QUANTITY",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.entry;
      },
    },
    {
      name: "exitQuantity",
      displayName: "ADMIN.GUEST_REPORT.EXIT_QUANTITY",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.leave;
      },
    },
    // {
    //   name: "",
    //   displayName: "",
    //   size: 1,
    //   sortable: false,
    // },
  ];

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    mobileViewBreakPoint: 992,
    headerStickyPosition: 395,
    mobileFilterButton: true,
    gridColumnsCount: 12,
    styleClasses: ["content-table"],
  };

  datePipe = new DateStiPipe(this.userServ);

  constructor(
    public alertController: AlertController,
    public translateService: TranslateService,
    public modalCtrl: ModalController,
    public popoverController: PopoverController,
    public translate: TranslateService,
    public p: ThisPlatform,
    public guestReportServ: GuestReportService,
    public buildingServ: BuildingService,
    private userServ: UserService,
    public companyServ: CompanyService,
    private dateTimeAdapter: DateTimeAdapter<any>
  ) {}

  async ngOnInit() {
    this.chartVariablesLoad();
    this.getGuestReports();
    this.onRefreshChart();

    this.dateTimeAdapter.setLocale(this.userServ.getDefaultLanguage());

    await this.buildingServ.loadBuildingsSync();
    await this.companyServ.loadCompaniesSync();

    this.guestReportServ.actualSubscription = this.guestReportServ.filterDetailsSubject.subscribe(
      () => {
        this.getFilterGuestReports();
      }
    );

    this.onRefreshChart();
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      this.showLoader = false;
      this.guestReportServ.getDataForChart(this.guestReportsFilter);
      this.guestReportsFilter = this.guestReportServ.guestReports.filter(
        (s) => {
          return (
            s.buildingName +
            " " +
            s.companyName +
            " " +
            this.datePipe.transform(s.date, "onlyDate") +
            " " +
            s.entry +
            " " +
            s.leave
          );
        }
      );
    }
    this.rowsLoader.init(this.guestReportsFilter);
  }

  rowsLoaderRefresh() {
    this.showLoader = false;
    this.rowsLoader.init(this.guestReportsFilter);
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  getGuestReports() {
    this.showLoader = true;
    this.guestReportServ.request = this.guestReportServ.requestParameters = {
      type: GuestReportType.Guest.toString(),
      dateFrom: this.monthBeforeCurrentDate().toISOString(),
      dateTo: this.currentDate().toISOString(),
    };

    this.guestReportServ
      .getGuestReports(this.guestReportServ.request)
      .subscribe((res) => {
        this.guestReportServ.guestReports = this.guestReportsFilter = res;
        this.rowsLoaderInit();
      });
  }

  getFilterGuestReports() {
    this.guestReportServ.request = {
      type: GuestReportType.Guest.toString(),
      dateFrom: this.guestReportServ.requestParameters.dateFrom
        ? this.guestReportServ.requestParameters.dateFrom
        : this.monthBeforeCurrentDate().toDateString(),
      dateTo: this.guestReportServ.requestParameters.dateTo
        ? this.guestReportServ.requestParameters.dateTo
        : this.currentDate().toDateString(),
      idBuilding: this.guestReportServ.requestParameters.building
        ? this.guestReportServ.requestParameters.building.id
        : null,
      idCompany: this.guestReportServ.requestParameters.company
        ? this.guestReportServ.requestParameters.company.id
        : null,
    };

    this.guestReportServ
      .getGuestReports(this.guestReportServ.request)
      .subscribe((res) => {
        this.guestReportServ.guestReports = this.guestReportsFilter = res;
        this.rowsLoaderRefresh();
        this.guestReportServ.refreshChart(this.guestReportsFilter);
        this.onRefreshChart();
      });
  }

  onFilterBuilding(building) {
    this.guestReportServ.requestParameters.building = building;
    this.getFilterGuestReports();
  }

  onFilterCompany(company) {
    this.guestReportServ.requestParameters.company = company;
    this.getFilterGuestReports();
  }

  onFilterDate(date, whichDate: string = "start" || "end") {
    if (whichDate == "start") {
      this.guestReportServ.requestParameters.dateFrom = date;
    } else if (whichDate == "end") {
      this.guestReportServ.requestParameters.dateTo = date;
    }

    this.getFilterGuestReports();
  }

  async onToggleFilter() {
    const modal = await this.modalCtrl.create({
      component: GuestReportModalFilterComponent,
      canDismiss: preventSwipeToClose,
      cssClass: "add-edit-modal mobile-filter__modal-container",
    });
    modal.present();
  }

  onRefreshChart() {
    this.guestReportServ.loadChart(
      this.guestReportServ.enter,
      this.guestReportServ.leave,
      this.guestReportServ.date
    );
  }

  chartVariablesLoad() {
    this.guestReportServ.defaultLocale = this.userServ.getDefaultLanguage();
    this.guestReportServ.chartHeader = this.translateService.instant(
      "ADMIN.GUEST_REPORT.HEADER"
    );
    this.guestReportServ.entires = this.translateService.instant(
      "ADMIN.GUEST_REPORT.ENTRY_QUANTITY"
    );
    this.guestReportServ.exits = this.translateService.instant(
      "ADMIN.GUEST_REPORT.EXIT_QUANTITY"
    );
    this.guestReportServ.noDataText = this.translateService.instant(
      "NO_DATA_TO_SHOW"
    );

    if (this.p.renderMobile) {
      this.guestReportServ.chartHeaderSize = "14px";
    } else {
      this.guestReportServ.chartHeaderSize = "28px";
    }
  }

  ngOnDestroy() {
    this.guestReportServ.requestParameters = {
      type: GuestReportType.Guest.toString(),
      dateFrom: this.monthBeforeCurrentDate().toDateString(),
      dateTo: this.currentDate().toDateString(),
      building: null,
      company: null,
    };
    this.guestReportServ.actualSubscription.unsubscribe();
  }

  private currentDate(): Date {
    return new Date(Date.now())
  }

  private monthBeforeCurrentDate(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 30))
  }
}
